import React from "react";
import { Link } from "react-router-dom";
import { IResearch } from "../hooks/useResearchData";

interface PublicationsTableProps {
  projects: IResearch[];
}

const PublicationsTable: React.FC<PublicationsTableProps> = ({ projects }) => {
  const formatAuthors = (author: string) => {
    if (!author) return "";
    const authors = author.split(", ");
    if (authors.length <= 3) return author;
    return `${authors.slice(0, 3).join(", ")}, et al.`;
  };

  return (
    <div className="relative overflow-hidden border border-gray-200 shadow sm:rounded-lg">
      <table className="w-full text-sm text-left text-gray-500">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50">
          <tr>
            <th scope="col" className="px-6 py-3 font-medium">
              Library Code
            </th>
            <th scope="col" className="px-6 py-3 font-medium">
              Publication
            </th>
            <th
              scope="col"
              className="px-6 py-3 font-medium text-center whitespace-nowrap"
            >
              # Formulations
            </th>
            <th
              scope="col"
              className="px-6 py-3 font-medium text-center whitespace-nowrap"
            >
              # Unique Ionizable Lipids
            </th>
          </tr>
        </thead>
        <tbody>
          {projects
            .filter(({ experiment_id }) => experiment_id !== null)
            .map((project, index) => {
              return (
                <tr key={index} className="bg-white border-b hover:bg-gray-50">
                  <td className="px-6 py-4 text-center">
                    <Link
                      to={`/search/text?filter=${encodeURIComponent(
                        JSON.stringify({ experiment_id: project.experiment_id })
                      )}`}
                      className="font-medium text-blue-600 hover:underline"
                    >
                      {project.experiment_id}
                    </Link>
                  </td>
                  <td className="px-6 py-4">
                    <div className="space-y-1">
                      <Link
                        to={project.doi}
                        target="_blank"
                        className="text-base font-medium text-blue-600 hover:underline"
                      >
                        {project.title}
                      </Link>
                      <div className="text-sm text-gray-600">
                        {formatAuthors(project.author)}
                      </div>
                      <div className="text-sm italic text-gray-600">
                        {project.journal}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <div className="inline-flex items-center justify-center px-3 py-1 font-medium text-center text-blue-800 bg-blue-100 rounded-full">
                      {project.lnp_count.toLocaleString()}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <div className="inline-flex items-center justify-center px-3 py-1 font-medium text-center text-green-800 bg-green-100 rounded-full">
                      {project.lnp_unique_count.toLocaleString()}
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default PublicationsTable;
